import { Card, CardContent } from '@/components/ui/card'

export function Dashboard() {
  return (
    <Card>
      <CardContent>
        <h1 className="mb-4">Dashboard</h1>
        <div className="h-64 rounded-lg bg-gray-200"></div>{' '}
      </CardContent>
    </Card>
  )
}
